// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__container--tKnnS {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.style__header--YHIQA {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.style__modulesContainer--Uq39J {
  overflow: auto;
  padding-top: 0.5rem;
}
.style__moduleTable--ECjHw {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid var(--sys-color-outline-variant);
  border-radius: 8px;
  overflow: hidden;
  font-size: 0.875rem;
  table-layout: fixed;
}
.style__moduleTable--ECjHw th, .style__moduleTable--ECjHw td {
  padding: 0.75rem 1rem;
  text-align: left;
  border-bottom: 1px solid var(--sys-color-outline-variant);
}
.style__moduleTable--ECjHw th {
  font-weight: 600;
  color: var(--sys-color-on-surface-variant);
  border-bottom: 2px solid var(--sys-color-outline-variant);
}
.style__moduleTable--ECjHw td {
  vertical-align: middle;
}
.style__moduleTable--ECjHw tr:last-child td {
  border-bottom: none;
}
.style__moduleTable--ECjHw tr:not(.style__groupRow--n7bro):hover td {
  background: var(--sys-color-surface-variant, rgba(0, 0, 0, 0.04));
}
.style__groupRow--n7bro td {
  background: var(--sys-color-surface-variant, rgba(0, 0, 0, 0.04));
}
.style__groupCell--f5YfK {
  padding: 0.75rem 1rem;
}
.style__thIndex--cvubI, .style__tdIndex--fgArZ {
  width: 3rem;
  text-align: center;
}
.style__thName--munJ6, .style__tdName--dQnZX {
  width: auto;
}
.style__thGear--YH3Mv, .style__tdGear--_IaU5 {
  width: 10rem;
}
.style__thVersions--sQ0Dc, .style__tdVersions--gsGaa {
  width: 14rem;
  white-space: normal;
  word-break: break-word;
}
.style__thDevices--iSNTT, .style__tdDevices--Roht3, .style__tdDevicesWarning--oOrxq {
  width: 6rem;
  text-align: center;
}
.style__tdDevicesWarning--oOrxq {
  color: #d66700;
  font-weight: 600;
}
.style__thEnabled--Q_Ukr, .style__tdEnabled--wcOTU {
  width: 5rem;
  text-align: center;
}
.style__emptyState--G28xz {
  padding: 2rem 0;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ModuleConfigPage/style.less"],"names":[],"mappings":"AAGA;EAEI,aAAA;EACA,sBAAA;EACA,SAAA;AAHJ;AADA;EAQI,aAAA;EACA,mBAAA;EACA,8BAAA;AAJJ;AANA;EAcI,cAAA;EACA,mBAAA;AALJ;AAVA;EAmBI,WAAA;EACA,yBAAA;EACA,kDAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AANJ;AAnBA;EA4BM,qBAAA;EACA,gBAAA;EACA,yDAAA;AALN;AAzBA;EAkCM,gBAAA;EACA,0CAAA;EACA,yDAAA;AANN;AA9BA;EAwCM,sBAAA;AAPN;AAjCA;EA4CM,mBAAA;AARN;AApCA;EAgDM,iEAAA;AATN;AAvCA;EAsDM,iEAAA;AAZN;AA1CA;EA2DI,qBAAA;AAdJ;AA7CA;EA+DI,WAAA;EACA,kBAAA;AAdJ;AAlDA;EAoEI,WAAA;AAdJ;AAtDA;EAwEI,YAAA;AAdJ;AA1DA;EA4EI,YAAA;EACA,mBAAA;EACA,sBAAA;AAdJ;AAhEA;EAkFI,WAAA;EACA,kBAAA;AAbJ;AAtEA;EAuFI,cAAA;EACA,gBAAA;AAdJ;AA1EA;EA4FI,WAAA;EACA,kBAAA;AAdJ;AA/EA;EAiGI,eAAA;EACA,kBAAA;AAfJ","sourcesContent":["@import '@yaak/components/src/spacing';\n@import '@yaak/components/src/colors';\n\n:local {\n  .container {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n  }\n\n  .header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .modulesContainer {\n    overflow: auto;\n    padding-top: @spacing-50;\n  }\n\n  .moduleTable {\n    width: 100%;\n    border-collapse: collapse;\n    border: 1px solid var(--sys-color-outline-variant);\n    border-radius: 8px;\n    overflow: hidden;\n    font-size: 0.875rem;\n    table-layout: fixed;\n\n    th, td {\n      padding: @spacing-75 @spacing-100;\n      text-align: left;\n      border-bottom: 1px solid var(--sys-color-outline-variant);\n    }\n\n    th {\n      font-weight: 600;\n      color: var(--sys-color-on-surface-variant);\n      border-bottom: 2px solid var(--sys-color-outline-variant);\n    }\n\n    td {\n      vertical-align: middle;\n    }\n\n    tr:last-child td {\n      border-bottom: none;\n    }\n\n    tr:not(.groupRow):hover td {\n      background: var(--sys-color-surface-variant, rgba(0, 0, 0, 0.04));\n    }\n  }\n\n  .groupRow {\n    td {\n      background: var(--sys-color-surface-variant, rgba(0, 0, 0, 0.04));\n    }\n  }\n\n  .groupCell {\n    padding: @spacing-75 @spacing-100;\n  }\n\n  .thIndex, .tdIndex {\n    width: 3rem;\n    text-align: center;\n  }\n\n  .thName, .tdName {\n    width: auto;\n  }\n\n  .thGear, .tdGear {\n    width: 10rem;\n  }\n\n  .thVersions, .tdVersions {\n    width: 14rem;\n    white-space: normal;\n    word-break: break-word;\n  }\n\n  .thDevices, .tdDevices, .tdDevicesWarning {\n    width: 6rem;\n    text-align: center;\n  }\n\n  .tdDevicesWarning {\n    color: @color-orange-050;\n    font-weight: 600;\n  }\n\n  .thEnabled, .tdEnabled {\n    width: 5rem;\n    text-align: center;\n  }\n\n  .emptyState {\n    padding: @spacing-200 0;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style__container--tKnnS`,
	"header": `style__header--YHIQA`,
	"modulesContainer": `style__modulesContainer--Uq39J`,
	"moduleTable": `style__moduleTable--ECjHw`,
	"groupRow": `style__groupRow--n7bro`,
	"groupCell": `style__groupCell--f5YfK`,
	"thIndex": `style__thIndex--cvubI`,
	"tdIndex": `style__tdIndex--fgArZ`,
	"thName": `style__thName--munJ6`,
	"tdName": `style__tdName--dQnZX`,
	"thGear": `style__thGear--YH3Mv`,
	"tdGear": `style__tdGear--_IaU5`,
	"thVersions": `style__thVersions--sQ0Dc`,
	"tdVersions": `style__tdVersions--gsGaa`,
	"thDevices": `style__thDevices--iSNTT`,
	"tdDevices": `style__tdDevices--Roht3`,
	"tdDevicesWarning": `style__tdDevicesWarning--oOrxq`,
	"thEnabled": `style__thEnabled--Q_Ukr`,
	"tdEnabled": `style__tdEnabled--wcOTU`,
	"emptyState": `style__emptyState--G28xz`
};
export default ___CSS_LOADER_EXPORT___;
